// Save-success modal bus - mirrors the "no-state, DOM-controlled" pattern
// used by footnoteModalBus, yearEndModalBus, etc.
//
// Instead of `useState<boolean>(showSaveSuccessModal)` (which re-renders the
// entire EditFilings tree, including all 12k+ inputs on consolidated filings),
// the modal is always mounted and toggled via DOM events. Context (error
// count, exit callback) is captured in a module-local variable before the
// open event fires.

export type SaveSuccessModalContext = {
  errorCount: number;
  onExit: () => void;
};

let currentContext: SaveSuccessModalContext | null = null;

export const SAVE_SUCCESS_MODAL_OPEN_EVENT = 'saveSuccessModal:open';
export const SAVE_SUCCESS_MODAL_CLOSE_EVENT = 'saveSuccessModal:close';

export function setSaveSuccessModalContext(ctx: SaveSuccessModalContext): void {
  currentContext = ctx;
}

export function getSaveSuccessModalContext(): SaveSuccessModalContext | null {
  return currentContext;
}

export function openSaveSuccessModal(): void {
  document.dispatchEvent(new CustomEvent(SAVE_SUCCESS_MODAL_OPEN_EVENT));
}

export function closeSaveSuccessModal(): void {
  document.dispatchEvent(new CustomEvent(SAVE_SUCCESS_MODAL_CLOSE_EVENT));
}
